import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromJS } from 'immutable';
import { useFetchye } from 'fetchye';
import { v4 as uuidv4 } from 'uuid';
import { setConversationId } from '../ducks';
import { GENERAL, MODULE_NAME, NOTELIGIBLE } from '../utils/constants';

const uuid = uuidv4();

export const useConversationSession = ({ apiUrl, errorScreen }) => {
  const dispatch = useDispatch();
  const conversationId = useSelector((state) => state.getIn(['modules', MODULE_NAME, 'conversationId'])
  );

  const { isLoading, data: sessionData } = useFetchye(`${apiUrl}/session`, {
    credentials: 'include',
    headers: {
      x_amex_tracking_id: uuid,
    },
    method: 'POST',
  });

  useEffect(() => {
    if (sessionData && !conversationId) {
      dispatch(setConversationId(fromJS(sessionData.body.conversation_id)));
    }
  }, [sessionData, conversationId, dispatch]);

  useEffect(() => {
    window.getConversationId = async () => ({
      conversationID: conversationId ?? null,
    });

    return () => {
      delete window.getConversationId;
    };
  }, [conversationId]);

  const sessionStatus = useMemo(() => {
    if (errorScreen === GENERAL || sessionData?.status === 500) return 500;
    if (errorScreen === NOTELIGIBLE || sessionData?.status === 403) return 403;
    return sessionData?.status ?? null;
  }, [errorScreen, sessionData?.status]);

  return {
    conversationId,
    isSessionLoading: isLoading,
    sessionStatus,
  };
};
